class Tags {

  constructor(basePath, apiClient) {

    this.basePath = `${basePath}/calendar-activity-tags`;
    this.apiClient = apiClient;

  }

  async createTag(data) {

    const path = `${this.basePath}`;

    return this.apiClient.post(path, {}, {}, data);

  }

  async getAllTags() {

    const path = `${this.basePath}`;

    return this.apiClient.get(path, {}, {});

  }

  async updateTagById(tagId, data) {

    const path = `${this.basePath}/:tagId`;

    return this.apiClient.put(path, { tagId }, {}, data);

  }

  async deleteTagById(tagId) {

    const path = `${this.basePath}/:tagId`;

    return this.apiClient.delete(path, { tagId }, {});

  }

}

export default Tags;